// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".friendship-level-root .van-swipe__indicators .van-swipe__indicator{width:.8rem;height:.10667rem;background:#e6e5e7!important;border-radius:.05333rem}.friendship-level-root .van-swipe__indicators .van-swipe__indicator--active{background:#b2b2b2!important}", ""]);
// Exports
module.exports = exports;
